<template lang="pug">
    v-card(v-if="show")
        v-layout.info-totals-area(
            wrap
            style="border-top: 1px solid #ddd;"
            )
            v-flex.md6
                v-chip(
                    small
                    v-if="customerData.personName && [2,3].includes(activeTransaction.id)"
                    ) 
                    span Cliente: {{customerData.personName || ''}}
            v-flex.md2
                v-chip(
                    small
                    color="red"
                    dark
                    v-if="chargePercentage"
                    ) 
                    span Recargo: {{parseFloat(chargePercentage)}} %
            v-flex.md2
                //span(v-if="items.length") líneas: {{items.length}}
                v-chip(small)
                    v-avatar.white--text(
                        :class="linesClasses"
                        ) 
                        span {{items.length}}
                    span Líneas
            v-flex.md2
                //span(v-if="items.length") unidades: {{units}}
                v-chip(small)
                    v-avatar.secondary.white--text(
                        :class="{subheading: units < 100, caption: units >= 1000}"
                        v-if="units < 1000"
                        )
                        span {{units}}
                    span {{units > 999 ? this.mixCurrencyFormatter( units ) : ''}} Unidades
        v-divider
        v-layout.d-flex.align-center.totals-container.px-3(row v-if="items.length > 0" style="overflow:hidden;")
            v-flex.xs3.px-3(style="overflow:hidden;")
                global-discount
            v-divider(vertical)
            v-flex.xs3.px-3
                div.d-flex.justify-space-between(v-if="[1,2].includes(activeTransactionIndex)")
                    span.headline IVA:
                    span.headline.text-xs-right {{getIVA | mixFormatCurrency}}
            v-divider(vertical v-if="activeTransactionIndex==1")
            v-flex.xs3.px-3
                div.d-flex.justify-space-between(v-if="[1,2].includes(activeTransactionIndex)")
                    span.headline NETO:
                    span.headline.text-xs-right {{getNeto | mixFormatCurrency}}
            v-divider(vertical v-if="activeTransactionIndex==1")
            v-flex.d-flex.justify-space-between.xs3.px-3(v-if="getTotal > 0")
                span.headline TOTAL:
                span.headline.text-xs-right.font-weight-bold {{getTotal | mixFormatCurrency}}
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import CurrencyUtils from '@/mixins/CurrencyUtils'
import GlobalDiscount from '@/components/GlobalDiscount/GlobalDiscount'
export default {
    name: 'sale-totals',
    props: {},
    data: function() {
        return {
            show: true,
        }
    },
    computed: {
        ...mapState('CartModule', {
            getTotal: 'total',
            items: 'items',
        }),
        ...mapGetters('CartModule', {
            getIVA: 'getIVA',
            getNeto: 'getNeto',
        }),
        ...mapGetters('TransactionModule', {
            activeTransaction: 'activeTransaction',
        }),
        ...mapState('TransactionModule', {
            activeTransactionIndex: 'activeTransactionIndex',
        }),
        ...mapState('CustomerModule', {
            customerData: 'customerData',
        }),
        ...mapGetters('CustomerModule', ['chargePercentage']),
        units() {
            if (!this.items || this.items.length === 0) return 0
            return this.items.reduce(
                (acc, itm) => acc + parseInt(itm.quantity),
                0
            )
        },
        linesClasses() {
            let secondary = true
            let danger = false
            let warning = false
            if (this.activeTransaction.id === 2 && this.items.length > 20) {
                secondary = false
                danger = true
            } else {
                if (
                    this.activeTransaction.id === 2 &&
                    this.items.length === 20
                ) {
                    secondary = false
                    danger = false
                    warning = true
                }
            }
            return {
                subheading: this.items.length < 100,
                caption: this.items.length >= 1000,
                secondary,
                'red darken-2': danger,
                'amber darken-3': warning,
            }
        },
    },
    methods: {},
    watch: {
        activeTransactionIndex: function(newVal) {
            if (newVal === 5) {
                this.show = false
            } else {
                this.show = true
            }
        },
    },
    components: { 'global-discount': GlobalDiscount },
    mixins: [CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
.totals-container {
    height: 50px;
}
.info-totals-area {
    margin-top: -15px;
}
</style>
